import * as types from './types';

// mutations
export default {
  /* eslint-disable no-param-reassign */
  [types.GET_USERS_SUCCESS](state, list) {
    state.users = list;
  },
  [types.GET_USERS_FAILED](state) {
    state.users = [];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js